module.exports = __webpack_public_path__ + "assets/pdf/transcript-en-podcast.d3e3f638.pdf";